import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import { Borrower } from 'app/models/dto/borrower.model';
import { BorrowerState } from 'app/store/borrower/borrower/borrower.state';
import { filter, Observable, Subject, takeUntil } from 'rxjs';
import { LenderUserState } from 'ng2-app/store/lender-user/lender-user/lender-user.state';
import { MatTabGroup } from '@angular/material/tabs';
import { EventBusService } from 'ng2-app/modules/shared/services/event-bus.service';
import { TodayPageState } from 'ng2-app/modules/today/state/today-page-state/today-page.state';
import { GetBorrowerDocuments } from 'ng2-app/store/documents/document.actions';
import { notNull } from 'app/modules/shared/functions/filters';

@Component({
  selector: 'app-user-action-item-borrower-pane',
  templateUrl: './user-action-item-borrower-pane.component.html',
  styleUrls: ['./user-action-item-borrower-pane.component.scss']
})
export class UserActionItemBorrowerPaneComponent implements OnInit, OnDestroy {

  borrower$: Observable<Borrower>;
  @Select(BorrowerState.loading) borrowerLoading$: Observable<boolean>;
  @Select(BorrowerState.applicationComplete) applicationComplete$: Observable<string | null>;
  @Select(LenderUserState.hasPermission('canViewBorrowerPaneDeals')) canViewBorrowerPaneDeals$: Observable<boolean>;
  @Select(TodayPageState.borrowerPaneWidth) borrowerPaneWidth$: Observable<number>;
  @ViewChild('tabs') tabs: MatTabGroup;

  destroyed$ = new Subject<boolean>();
  selectedTabIndex: number;

  namedTabs = [
    'activity',
    'contacts',
    'businessInfo',
    'deals',
    'documents',
    'notes',
  ];

  constructor(
    private store: Store,
    private eventBusService: EventBusService,
  ) { }

  ngOnInit(): void {
    this.borrower$ = this.store.select(BorrowerState.borrower).pipe(filter(borrower => !!borrower)) as Observable<Borrower>;

    this.eventBusService.subscribe( this.eventBusService.types.ChangeBorrowerPaneTabEvent ).subscribe( tabName => {
      this.activateTabByName(tabName);
    });

    this.borrowerPaneWidth$.subscribe( () => this.tabs?.updatePagination() );

    this.borrower$
    .pipe(
      filter(notNull),
      takeUntil(this.destroyed$)
    )
    .subscribe( borrower => {
      this.store.dispatch(new GetBorrowerDocuments(borrower.id));
    });
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  activateTabByName({tabName}) {
    const index = this.namedTabs.indexOf(tabName);
    if(index !== -1) {
      this.selectedTabIndex = index;
    }
  }

}
